import { CardBase, Checkbox, Space, Typography } from '@honestica/ui-kit/src';
import { useTranslation } from 'react-i18next';

interface Props {
  className?: string;
  disabled?: boolean;
  value: boolean;
  onValueChange: (value: boolean) => void;
}

export function MyRequestOnlySetting(props: Props) {
  const { t } = useTranslation();

  return (
    <CardBase className={props.className}>
      <Space direction="vertical">
        <Checkbox
          disabled={props.disabled}
          checked={props.value}
          onClick={() => props.onValueChange(!props.value)}
        >
          <Typography.Text strong>
            {t('desktopSettings.myRequestOnly.checkboxLabel')}
          </Typography.Text>
        </Checkbox>

        <Typography.Text>{t('desktopSettings.myRequestOnly.description')}</Typography.Text>
      </Space>
    </CardBase>
  );
}
